const toLink = (titulo) => titulo.toLowerCase().replace(/ /g, "_")

export default toLink